// extracted by mini-css-extract-plugin
export default {"align_vertical":"RadioGroup_align_vertical__54s7o","align_horizontal":"RadioGroup_align_horizontal__MaIhI"};